import React from "react";
import field from "../../img/field.png";
import { Formation } from "../../interfaces/Formation.Interface";
import { Player } from "../../interfaces/Player.Interface";
import image from "../../img/player_default.png";
import { v4 } from "uuid";
import "./TeamSheet.Styles.scss";

interface Props {
  formation: Formation;
  players: (Player | null)[];
  start: number;
}

export default function TeamSheetComponent(props: Props) {
  const renderPlayers = (start: number, count: number) => {
    const playerData: JSX.Element[] = [];

    for (let i = start; i < start + count; i++) {
      const ele = renderPosition(props.players, i);
      playerData.push(ele);
    }

    return playerData;
  };

  const renderPosition = (players: (Player | null)[], position: number) => {
    const player = players[position];

    if (player) {
      return (
        <div key={v4()} className="team-player-element">
          <img alt="" src={player.imageUrl || image} />
          <div className="jersey-number">{player.jerseyNumber}</div>
          <div>{player.firstName}</div>
        </div>
      );
    } else {
      return <div key={v4()}></div>;
    }
  };

  const { foward, defend, midfield } = props.formation;
  const { start } = props;

  return (
    <div className="team-sheet-container">
      <div className="field">
        <img src={field} alt="" />
      </div>
      <div className="positions">
        <div className="fowards">
          {renderPlayers(midfield + defend + start, foward)}
        </div>
        <div className="midfielders">
          {renderPlayers(defend + start, midfield)}
        </div>
        <div className="defenders">{renderPlayers(start, defend)}</div>
        <div className="goalkeeper">
          {renderPlayers(start === 11 ? 11 : 0, 1)}
        </div>
      </div>
    </div>
  );
}
